import * as React from 'react';
import { Box, Typography } from '@mui/material';
import AccordionClose from '../../assets/accordion-close.svg'

const CourseAccordion = ()=>{
    const course__outline = [
        {
            title:'Introduction',
            time:45,
            description:'Overview of social media marketing and its significance for Nigerian businesses.'
        },
        {
            title:'Building Engagement',
            time:45,
            description:'Tips for fostering audience interaction and brand loyalty.'
        },
        {
            title:'Content Marketing',
            time:45,
            description:'Creating high-performance content for platforms like Instagram, Facebook, and Twitter.'
        },
        {
            title:'Analytics & Reporting',
            time:45,
            description:'How to use Google Analytics and Facebook Ads Manager to track campaign performance.'
        },
        {
            title:'Capstone Project',
            time:45,
            description:'Create a campaign for a Lagos-based business to apply learned strategies.'
        },
    ]

  return (
    <Box>
        {
            course__outline.map((item, index)=>{
                return <Box key={index} sx={{backgroundColor:'rgba(255, 255, 255, 1)', border:'1px solid rgba(210, 209, 214, 1)', p:2, my:2, borderRadius:'12px',fontFamily: theme=> theme.typography.smallText,}}>
                        <Box sx={{display:'flex', gap:2, justifyContent:'space-between', borderBottom:'1px solid rgba(238, 230, 254, 1)', pb:1}}>
                            <Box sx={{display:'flex', gap:1}}>
                                <img src={AccordionClose} alt="accordion-close" />
                                <Typography variant='h6'>{item.title}</Typography>
                            </Box>
                            <Typography sx={{color:'rgba(86, 4, 246, 1)'}}>
                                {item.time} Mins
                            </Typography>
                        </Box>
                        <Typography sx={{my:2, color:'rgba(18, 18, 18, 1)'}}>{item.description}</Typography>
                    </Box>
            })
        }
    </Box>
  );
}

export default CourseAccordion